import { URLS } from 'utils/tests/urls.config';
import { lendingApiFetchJson } from './lendingApi';

export type TNotificationSubscription = {
  status: string;
  subscribed: boolean;
};

export type TNotification = {
  created: string;
  notification_id: string;
  application_id: string;
  status: 'action_required' | 'offered';
  read_time?: string;
  company_name?: string;
};

export type TNotificationsPayload = {
  notifications: TNotification[];
  pages: number;
  results: number;
  next_page: number | null;
  unread_notifications: number;
};

// TODO: Replace with the lapi fetcher when patch becomes supported
export function patchNotification(
  introducerId: string,
  applicationId: string,
  notificationId: string,
  data: any,
): Promise<{ data: { [key: string]: string } }> {
  return lendingApiFetchJson(
    URLS.patchNotifications({ introducerId, applicationId, notificationId }),
    { method: 'PATCH', body: JSON.stringify({ data }) },
    {},
    () => {},
    { success: true },
  );
}

export function patchAllNotifications(
  introducerId: string,
  data: any,
): Promise<{ data: { [key: string]: string } }> {
  return lendingApiFetchJson(
    URLS.patchAllNotifications({ introducerId }),
    { method: 'PATCH', body: JSON.stringify({ data }) },
    {},
    () => {},
    { success: true },
  );
}

export function patchSubscriptions(
  introducerId: string,
  data: any,
): Promise<{ data: { [key: string]: string } }> {
  return lendingApiFetchJson(
    URLS.patchSubscriptions({ introducerId }),
    { method: 'PATCH', body: JSON.stringify({ data }) },
    {},
    () => {},
    { success: true },
  );
}
